import type { LegacyRiskGapStatus } from '@ctw/shared/api/fhir/models/risk-gap';

export const isRiskGapNoteEditable = (status: LegacyRiskGapStatus) => status === 'open-gap';
